// React context that exposes the Leaflet map instance to children of
// <ForecastMap/>. Future overlay layers (e.g. <ForecastRasterOverlay/>,
// <AirspaceLayer/>) read the map via useForecastMap() and add their Leaflet
// layer in a useEffect — they don't have to modify ForecastMap itself.

import { createContext, useContext } from 'react';

const ForecastMapContext = createContext(null);

export const ForecastMapProvider = ForecastMapContext.Provider;

export const useForecastMap = () => useContext(ForecastMapContext);
